import { render } from "./codeDetail.vue?vue&type=template&id=f399405e"
import script from "./codeDetail.vue?vue&type=script&lang=js"
export * from "./codeDetail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__